import { motion, useReducedMotion } from "framer-motion";
import {
    Accordion,
    AccordionContent,
    AccordionItem,
    AccordionTrigger,
} from "@/components/ui/accordion";

const FAQS = [
    {
        q: "In welchen Regionen ist Alpen Reinigung tätig?",
        a: "Wir reinigen in Innsbruck und im gesamten Tiroler Raum – darunter Hall in Tirol, Telfs, Wattens, Schwaz, Wörgl, Kufstein und Seefeld. Auf Anfrage übernehmen wir auch Aufträge im erweiterten Umkreis.",
    },
    {
        q: "Wie schnell bekomme ich ein Angebot für eine Reinigung in Innsbruck?",
        a: "Wir melden uns in der Regel innerhalb von 24 Stunden mit einem unverbindlichen Angebot zurück. Bei dringenden Anliegen erreichen Sie uns direkt unter +43 676 7092658.",
    },
    {
        q: "Reinigen Sie auch Photovoltaik-Anlagen in Tirol?",
        a: "Ja, die professionelle Reinigung von Photovoltaik-Anlagen ist Teil unserer Spezialreinigung. Eine regelmäßige Reinigung erhöht den Ertrag und verlängert die Lebensdauer der Module.",
    },
    {
        q: "Übernehmen Sie auch Bauendreinigung und Grundreinigung?",
        a: "Ja, wir führen Bauendreinigung sowie Grund- und Erstreinigung in Innsbruck und Tirol durch – inklusive Entfernung von Bauschmutz, Staub sowie Klebe- und Farbresten.",
    },
    {
        q: "Bieten Sie Winterdienst und Hausmeisterservice in Innsbruck an?",
        a: "Ja. Im Rahmen unseres Hausmeisterservice übernehmen wir Schneeräumung und Streudienst (24/7 Bereitschaft im Winter), Gartenpflege, Müllraum- und Außenbereich-Pflege sowie regelmäßige Kontrollgänge und Kleinreparaturen.",
    },
    {
        q: "Was kostet eine Entrümpelung in Innsbruck?",
        a: "Der Preis hängt von Wohnfläche, Aufzugssituation und Menge des Räumguts ab. Verwertbare Gegenstände rechnen wir auf den Preis an. Sie bekommen nach einer kurzen Besichtigung ein faires Fixpreis-Angebot – inklusive fachgerechter Entsorgung.",
    },
    {
        q: "Arbeiten Sie auch für private Haushalte?",
        a: "Ja. Neben Gewerbekunden, Hausverwaltungen und Bürogebäuden betreuen wir auch private Haushalte – diskret, zuverlässig und mit fester Ansprechperson.",
    },
    {
        q: "Wie läuft die Unterhaltsreinigung in der Praxis ab?",
        a: "Nach einer kurzen Besichtigung definieren wir gemeinsam Reinigungsplan, Frequenz (täglich / wöchentlich / monatlich) und Ansprechperson. Sie bekommen ein faires Festpreisangebot und eine saubere Dokumentation der Einsätze.",
    },
    {
        q: "Sind Sie versichert?",
        a: "Ja, Alpen Reinigung ist über eine gewerbliche Haftpflichtversicherung versichert. Auf Wunsch lassen wir Ihnen vor Auftragsbeginn die entsprechenden Nachweise zukommen.",
    },
];

export default function FAQ() {
    const reduce = useReducedMotion();
    return (
        <section
            id="faq"
            data-testid="faq-section"
            className="relative py-20 sm:py-24 lg:py-28 border-t border-white/[0.06]"
        >
            <div className="max-w-3xl mx-auto px-4 sm:px-6 lg:px-8">
                <p className="text-xs font-mono uppercase tracking-[0.2em] text-[#7BD3FF]">
                    FAQ
                </p>
                <h2 className="mt-3 font-heading text-3xl sm:text-4xl font-semibold tracking-tight text-white">
                    Häufige Fragen zur <span className="text-chrome">Reinigung in Innsbruck</span>.
                </h2>
                <p className="mt-4 text-[#C9D3E1] leading-relaxed">
                    Antworten auf die wichtigsten Fragen rund um Gebäudereinigung,
                    Fensterreinigung, Fassadenreinigung und Spezialreinigung in
                    Innsbruck und Tirol.
                </p>

                <motion.div
                    initial={reduce ? false : { opacity: 0, y: 10 }}
                    whileInView={{ opacity: 1, y: 0 }}
                    viewport={{ once: true, margin: "-40px" }}
                    transition={{ duration: 0.5 }}
                    className="mt-10 rounded-2xl border border-white/[0.10] bg-[rgba(14,20,31,0.7)] backdrop-blur-md p-2 sm:p-4 card-elevated"
                >
                    <Accordion type="single" collapsible className="w-full">
                        {FAQS.map((item, idx) => (
                            <AccordionItem
                                key={item.q}
                                value={`item-${idx}`}
                                className="border-b border-white/[0.08] last:border-b-0"
                            >
                                <AccordionTrigger
                                    className="text-left text-white hover:no-underline px-4 py-4 font-heading text-base sm:text-lg"
                                    data-testid={`faq-trigger-${idx}`}
                                >
                                    {item.q}
                                </AccordionTrigger>
                                <AccordionContent className="px-4 pb-4 text-[#C9D3E1] leading-relaxed">
                                    {item.a}
                                </AccordionContent>
                            </AccordionItem>
                        ))}
                    </Accordion>
                </motion.div>
            </div>
        </section>
    );
}
